module.exports = __webpack_public_path__ + "static/media/buddy_bundle-dt-en.30b29d81.jpg";